const a = {
  id: "PowerBallXsAndOs",
  name: "Powerball Xs & Os™",
  style: {
    colorPrimary: "#39B54A",
    teamColor: {
      ari: "#97233f",
      atl: "#a71930",
      bal: "#24135f",
      buf: "#c60c30",
      car: "#0085cf",
      chi: "#e64100",
      cin: "#fb4f14",
      cle: "#ff3c00",
      dal: "#002244",
      den: "#fc4c02",
      det: "#0076b6",
      gb: "#203731",
      hou: "#eb0028",
      ind: "#013369",
      jax: "#006778",
      kc: "#e31837",
      lac: "#0080c6",
      lar: "#003594",
      lv: "#000000",
      mia: "#008e97",
      min: "#4f2683",
      ne: "#002244",
      no: "#000000",
      nyg: "#0b2265",
      nyj: "#115740",
      phi: "#004851",
      pit: "#000000",
      sea: "#002244",
      sf: "#aa0000",
      tb: "#a71930",
      ten: "#4495d2",
      was: "#5a1414"
    }
  }
};
export {
  a as default
};
